import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Input as InputComponent } from 'web-ui-components/lib/atoms/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';

export class InputElement extends Component {
	componentDidUpdate() {
		const { isFocusOn, id } = this.props;
		if (isFocusOn && this[id]) {
			this[id].focus();
		}
	}
	render() {
		const {
			id,
			value,
			type,
			onChange,
			onFocus,
			onBlur,
			maxLength,
			className,
			autoComplete = true,
			disabled,
		} = this.props;
		return (
			<InputComponent
				id={id}
				type={type}
				value={value}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
				maxLength={maxLength}
				className={className}
				autoComplete={autoComplete ? 'on' : 'off'}
				disabled={disabled}
				ref={(element) => {
					this[id] = element;
				}}
			/>
		);
	}
}

InputElement.propTypes = {
	id: PropTypes.string,
	value: PropTypes.string,
	type: PropTypes.string,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	maxLength: PropTypes.string,
	className: PropTypes.string,
	autoComplete: PropTypes.bool,
	disabled: PropTypes.bool,
	isFocusOn: PropTypes.bool,
};

const handleBlockFieldColumn = (id, { enable, column, hasStack }, rest) => {
	if (enable) {
		return (
			<BlockFieldColumn column={column} hasStack={hasStack}>
				<InputElement id={id} {...rest} />
			</BlockFieldColumn>
		);
	}
	return <InputElement id={id} {...rest} />;
};

const Input = ({ id, label, errorMessage, description, blockField, isValid, showValidation, children, ...rest }) => (
	<Field>
		<FieldHeader
			name={id}
			titleText={label}
			validationMessage={errorMessage}
			description={description}
			hasError={!isValid && showValidation}
		/>
		<FieldBody hasError={!isValid && showValidation}>
			{handleBlockFieldColumn(id, blockField, { isValid, showValidation, ...rest })}
		</FieldBody>
		{children}
	</Field>
);
Input.propTypes = {
	id: PropTypes.string,
	label: PropTypes.string,
	errorMessage: PropTypes.string,
	description: PropTypes.string,
	blockField: PropTypes.shape({
		enable: PropTypes.bool,
		column: PropTypes.number,
		hasStack: PropTypes.bool,
	}),
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	children: PropTypes.node,
};

Input.defaultProps = {
	blockField: {
		enable: false,
		hasStack: false,
	},
};

export default Input;
